<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.headline_label', 'Headline')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.cta_banner.subtext', 'Subtext')">
    <UTextarea
      v-model="block.data.subtext"
      :rows="2"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.button_text', 'Button text')">
    <UInput
      v-model="block.data.button_text"
      class="w-full"
    />
  </UFormField>
  <UFormField
    :label="t('site.f.common.button_url_label', 'Button URL')"
    :help="t('site.f.cta_banner.the_button_is_hidden_unless_both_text_an_help', 'The button is hidden unless both text and a URL are set. For a join button that needs no URL, use the Join button block instead.')"
  >
    <UInput
      v-model="block.data.button_url"
      class="w-full"
    />
  </UFormField>
</template>
